import styled from 'styled-components/macro';

import Button from 'components/ui/Button';
import {
  brand,
  brandLight,
  black,
  grey70,
  grey10,
  grey50,
  grey5,
} from 'variables/colors';
import { FlexCenter, FlexCenterVertical } from 'styles/flexbox';
import { CardHeavyShadow } from 'styles/card';
import { borderRadius } from 'variables/general';
import { fontWeightSemiBold } from 'variables/font';

export const Component = styled.div`
  position: relative;
`;

export const DateBar = styled(FlexCenterVertical)`
  height: 3em;
  margin-bottom: 0.5em;
`;

export const Navigation = styled(FlexCenterVertical)``;

export const Date = styled.h4`
  width: 100%;
  max-width: 11em;
  margin-right: 1em;
`;

export const ActionBar = styled(FlexCenterVertical)`
  gap: 0.5em;
  margin-bottom: 1.5em;
`;

export const ActionButton = styled(Button)`
  height: 2.5em;
  padding: 1em 0.5em;
  font-size: 0.75em;

  .MuiSvgIcon-root {
    color: ${black};
  }
`;

export const BlockOffMenu = styled(CardHeavyShadow)`
  position: absolute;
  z-index: 10000;
  width: 100%;
  max-height: 30em;
  overflow-y: auto;
`;

export const Slots = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`;

export const SlotButton = styled.div`
  width: 8em;
  padding: 1em;
  color: ${grey70};
  font-weight: ${fontWeightSemiBold};
  text-align: center;
  border: 2px solid ${grey10};
  border-radius: ${borderRadius};

  &.active {
    color: ${black};
    background-color: ${grey5};
    border: 3px solid ${grey70};
  }
`;

export const BlockMenuHeading = styled.h6`
  margin: 1.5em 2em 1.5em 0;
  color: ${grey50};
  text-align: right;
  text-transform: uppercase;
`;

export const BlockActions = styled(FlexCenterVertical)`
  display: none;
  width: 8.5em;

  &.active {
    display: flex;
  }
`;

export const BlockCount = styled(FlexCenter)`
  width: 2em;
  height: 2em;
  margin: 0 0.25em;
  color: ${brand};
  background-color: ${brandLight};
  border-radius: 10em;
`;

export const Slot = styled(FlexCenterVertical)`
  justify-content: space-between;

  &:hover {
    ${BlockActions} {
      display: flex;
    }
  }
`;

export const IconButtonWrapper = styled.div`
  width: 3em;
  height: 3em;
`;
